<template>
  <div class="w-100">
    <div class="row">
      <div class="col-12">
        <div class="z-card border-0">
          <div class="row">
            <z-form ref="form" class="col-6" tag="div">
              <base-form v-model="base_form" />
            </z-form>
          </div>

          <div class="row mt-4">
            <div class="col-6">
              <contact-method-form v-model="contact_methods_form" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <i-button type="primary" size="large" :loading="is_loading" @click="save">
          {{ $t('shared.component.button.save') }}
        </i-button>
      </div>
    </div>
  </div>
</template>

<script>
  import differenceBy from 'lodash-es/differenceBy';
  import BaseForm from './base-form';
  import ContactMethodForm from './contact-method-form';
  import { ContactService } from '@pbx/services/ContactService';
  import { ContactMethodService } from '@pbx/services/ContactMethodService';
  import { PageServerValidationResponseMixin } from '@shared/mixins/page-server-validation-response';

  export default {
    components: { BaseForm, ContactMethodForm },
    mixins: [PageServerValidationResponseMixin],
    props: {
      id: {
        type: [Number, String],
        default: null
      },

      item: {
        type: Object,
        default: () => ({})
      },

      contact_methods: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        base_form: {},
        contact_methods_form: [],
        is_loading: false
      };
    },

    computed: {
      removed_methods: function() {
        return differenceBy(this.contact_methods, this.contact_methods_form, 'id');
      },

      added_methods: function() {
        return differenceBy(this.contact_methods_form, this.contact_methods, 'id');
      }
    },

    watch: {
      item: {
        handler: function(item) {
          this.base_form = item;
        },
        immediate: true,
        deep: true
      },

      contact_methods: {
        handler: function(items) {
          this.contact_methods_form = items;
        },
        immediate: true,
        deep: true
      }
    },

    methods: {
      save: function() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            this.is_loading = true;
            const request = this.id
              ? ContactService.editItem(this.id, this.base_form)
              : ContactService.createItem(this.base_form);

            /**
             * TODO :: Поговорить с Кириллом, много запросов
             */
            request
              .then(contact => {
                const contact_methods_remove_request = this.removed_methods.map(m =>
                  ContactMethodService.removeItem(contact.id, m.id)
                );

                const contact_methods_create_request = this.added_methods.map(method =>
                  ContactMethodService.createItem(contact.id, method)
                );

                return Promise.all([
                  ...contact_methods_remove_request,
                  ...contact_methods_create_request
                ]);
              })
              .then(() => this.$router.push({ name: 'pbx.contact.index' }))
              .catch(e => this.check_server_validation(e))
              .finally(() => (this.is_loading = false));
          }
        });
      }
    }
  };
</script>
